import React, { FunctionComponent } from "react";
import { Switch, Route, withRouter, RouteComponentProps } from "react-router";
import { TerminalUsers } from "./TerminalUser/TerminalUsers";



const TerminalUsersManagementRoutes: FunctionComponent<RouteComponentProps> = ({
  match: { url }
}) => (
  <Switch>
    
    <Route exact path={`${url}/`} render={() => <TerminalUsers />} />
  </Switch>
);

export const TerminalUsersManagement = withRouter(TerminalUsersManagementRoutes);
